<template>
    <v-container fluid class="pt-0">
        <v-row align="center" justify="center" >
            <v-col cols="12" sm="12" md="12">
                <v-card class="elevation-4">
                    <v-overlay v-model="overlay" 
                            color= "#FE5800" >
                            <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                    <v-card-title>
                        Create Event Category
                        <div class="flex-grow-1"></div>
                        <!-- <v-btn color="primary" @click="$router.push('/idtypelist')">ID Type List</v-btn> -->
                    </v-card-title>

                    <v-card-text>
                         <v-divider></v-divider>
                        <v-form v-model="valid" enctype="multipart/form-data" id="createEventCategory">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <h4 class="title">Category Information</h4>
                                    </v-col>
                                </v-row>
                                
                                 <v-row>
                                    <v-col cols="12" md="12">
                                        <v-text-field
                                        v-model="name"
                                        name="name"
                                        label="Event Category Name"
                                        required
                                        v-validate="'required|max:255'"
                                        :error-messages="errors.collect('name')"
                                        data-vv-name="name"
                                        ></v-text-field>
                                    </v-col>
                                    
                                </v-row>
                                
                                
                                 
                               
                                <v-divider></v-divider>
                                <div class="my-3">
                                <v-btn color="primary" @click="submit">Save</v-btn>
                                </div>
                            </v-container>
                        </v-form>
                    </v-card-text>


                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>
<script>
    import Vue from 'vue'
    import VeeValidate from "vee-validate";
    import { Cropper } from 'vue-advanced-cropper'
    import Editor from '@tinymce/tinymce-vue'


    Vue.use(VeeValidate);
    export default
    {

        props: 
        {
            source: String
        },
        data: () => 
        ({
            valid: true,
            name:"",
            description:"",
            dictionary: 
            {
                attributes: {
                    name: "Event Category Name",
                },
                custom: {}
            },
            business_id:0,
            overlay:false,

        }),
        mounted() 
        {
            this.$validator.localize("en", this.dictionary);
        },
        created() 
        {
            // if(this.$route.params.business_id)
            // {
            //     this.business_id=this.$route.params.business_id;
            // }
            this.storeBusiness=JSON.parse(localStorage.getItem('business'));

            this.business_id=this.storeBusiness.id;

            
        },
        methods: 
        {
            submit() {
                let th = this;
                if (this.$validator.validateAll()) {
                    let fd = new FormData(document.getElementById("createEventCategory"));

                    
                    fd.append('businesses_id',this.business_id);

                    
                    this.overlay=true;

                    this.$http
                    .post(this.$apidomain+"createeventcategorypwa", fd)
                    .then(res => {
                        if(res.data.success)  
                        {
                            this.overlay=false;
                            
                            this.$router.push({name:'eventcategorylist'});
                            
                        //this.$router.push("/courselist");
                        }  
                        else
                        {
                            let errmsg=[];
                            for(var prop in res.data.errors){
                                errmsg.push(res.data.errors[prop][0]);
                            }
                            this.overlay=false;

                            //alert(errmsg[0]);
                        }
                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                }
            }

        }
    }
</script>
